module.exports = __webpack_public_path__ + "static/media/213-gibraltar.7a348e6a.svg";